<template>
  <div class="modal-produto" v-if="aberto">
    <div id="modalProdutoContent" class="modal-produto-content" tabindex="1">
      <div class="header-produto py-4 py-md-3 bg-white shadow-sm">
        <div class="container text-center">
          <div class="position-relative">
            <a href="javascript:" @click="previusStep(true)" class="btn btn-outline-light position-absolute" style="left: 0; top: -9px; border-radius: 50%" aria-label="Voltar">
              <i class="fa fa-chevron-left text-dark"></i>
            </a>
            <h1 class="h6 font-weight-bold m-auto" style="max-width: 60%; text-overflow: ellipsis; white-space: nowrap; overflow: hidden">
              <span :class="{'text-white': load}">{{produto.nome_produto ? produto.nome_produto : ' - '}}</span>
            </h1>
            <a href="javascript:" @click="closeProduto(true)" class="btn btn-outline-light position-absolute" style="right: 0; top: -9px; border-radius: 50%" aria-label="Voltar" v-show="step > 1">
              <i class="fa fa-times text-dark"></i>
            </a>
          </div>
        </div>
      </div>
      <div id="containerProduto" class="container-produto">
        <loading v-show="load" class="mt-4"/>
        <div class="row no-gutters" v-if="!load && produto.tabelas">
          <div class="col-md-6 d-md-block my-3" v-show="step === stepImg">
            <div class="container" style="position: sticky; top: 16px">
              <produto-descricao :produto="produto" @modalImage="$emit('modalImage', produto.url_imagem)"/>
            </div>
          </div>
          <div class="col-md-6">
            <div v-if="produto.tabelas.length > 1" v-show="step === 0">
              <div class="bg-gray">
                <div id="tabelaProduto" class="container" style="position: relative">
                  <div class="d-flex justify-content-between py-4">
                    <h6 class="mb-0">Escolha 1</h6>
                    <i class="fa fa-check text-primary icon-check" v-show="dados.produto.id_tabela_preco"></i>
                    <span class="badge badge-primary float-right" v-show="!dados.produto.id_tabela_preco">Obrigatório</span>
                  </div>
                </div>
              </div>
              <div class="container px-0">
                <div class="lista-produto" :class="{'produto-disable': parseInt(t.qtd_estoque) <= 0, 'produto-selecionado': t.id_tabela_preco === dados.produto.id_tabela_preco}"
                     v-for="t in produto.tabelas" @click="selecionarTamanho(t)">
                  <div class="col lista-produto-item">
                    <div>
                      <h6 class="m-0" style="font-size: 16px">{{t.nome_tabela}}</h6>
                      <p class="tamanho-2 text-muted font-weight-bold m-0" v-if="t.valor > 0">
                        <span v-show="t.valor_base > 0 && t.valor_base > t.valor">De: <del class="text-danger pr-1"> {{t.valor_base | valor}}</del> por:</span>
                        <span class="mt-2 valor" v-show="t.valor > 0"> {{t.valor | valor}}</span>
                      </p>
                      <div>
                          <span class="badge badge-light font-weight-normal" v-if="t.turnos && t.disponivel === '0'">
                            <i class="fa fa-clock-o text-primary"></i> Disponível das <b class="text-primary">{{t.turnos}}</b>
                          </span>
                        <span class="badge border border-secondary text-secondary" v-else-if="t.qtd_estoque <= 0">sem estoque</span>
                        <produto-consumo :consumo="t.tipo_consumo" :tipo_pedido="sacola.tipo_pedido" v-else/>
                      </div>
                    </div>
                  </div>
                  <div class="pr-2 text-right">
                    <i class="fa" style="font-size: 24px"
                       :class="t.id_tabela_preco === dados.produto.id_tabela_preco ? 'fa-circle-o text-primary' : 'fa-circle text-light'"></i>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="produto.divisao > 0 && produto.divisoes.length > 0" v-show="step === 1">
              <div id="produtoDivisao" class="bg-gray topbar-produto">
                <div class="container">
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <h6 class="mb-0">Selecione {{produto.divisao}} sabor{{produto.divisao > 1 ? 'es' : ''}}</h6>
                      <span>Selecionado {{dados.divisoes.length}} de {{produto.divisao}}</span>
                    </div>
                    <div>
                      <span class="badge badge-primary float-right" v-show="dados.divisoes.length === 0">Obrigatório</span>
                      <i class="fa fa-check text-primary icon-check" v-show="dados.divisoes.length === parseInt(produto.divisao)"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="container px-0">
                <div v-show="produto.divisoes.length > 6" v-if="step === 1">
                  <div class="d-flex justify-content-between border-bottom pb-3 mt-3 px-2">
                    <VueFuse :list="produto.divisoes" :fuse-opts="options" :map-results="true" placeholder="Pesquisar sabor.."
                             class="form-control mr-2" ref="fuseDivisao" @fuse-results="handleResult"/>
                    <button class="btn btn-primary px-3"><i class="fa fa-search"></i></button>
                  </div>
                </div>
                <div class="lista-produto" v-for="d in searchDivisao" v-show="(d.id_tabela === dados.produto.id_tabela) || !dados.produto.id_tabela"
                     @click="selecionarDivisao(d)" :class="{'produto-disable' : !dados.produto.id_tabela, 'produto-selecionado': dados.divisoes.find(div => div.id_tabela_preco === d.id_tabela_preco)}">
                  <div class="col lista-produto-item">
                    <div class="mr-2">
                      <img :src="d.url_imagem" :alt="d.nome_produto" v-if="d.url_imagem"/>
                    </div>
                    <div>
                      <h6 class="mt-0 mb-1" style="font-size: 16px">{{d.nome_produto}}</h6>
                      <p class="m-0 text-muted tamanho-2">
                        <span class="mb-1" v-if="d.descricao_produto">{{d.descricao_produto}} <br></span>
                        <span v-show="d.valor_base > 0 && d.valor_base > d.valor">De: <del class="text-danger pr-1"> {{d.valor_base | valor}}</del> por: </span>
                        <span class="mt-2 text-dark font-weight-bold" v-if="d.valor > 0">{{d.valor | valor}}</span>
                      </p>
                    </div>
                  </div>
                  <div class="pr-2 text-right">
                    <i class="fa" style="font-size: 24px" :class="dados.divisoes.find(div => div.id_tabela_preco === d.id_tabela_preco) ? 'fa-circle-o text-primary' : 'fa-circle text-light'"></i>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="produto.adicionais && produto.adicionais.length">
              <div v-for="(g, index) in produto.adicionais" v-show="step === (index + 2)" :id="'grupoAdicional' + index">
                <div class="bg-gray topbar-produto border-bottom pointer">
                  <div class="container">
                    <div class="d-flex justify-content-between align-items-center">
                      <div>
                        <h6 class="mb-0">{{g.nome_grupo}}</h6>
                        <div class="small font-weight-bold" v-if="g.qtd_min > 0 || g.qtd_max > 0">
                          <span v-if="g.qtd_min > 0">Mínimo {{g.qtd_min}}</span>
                          <span v-if="g.qtd_min > 0 && g.qtd_min < g.qtd_max"> e </span>
                          <span v-if="g.qtd_min < g.qtd_max">Máximo {{g.qtd_max}}</span>
                          <div v-if="g.qtd_sel !== '1'"> ({{g.selecionados}} de {{g.qtd_max}})</div>
                        </div>
                      </div>
                      <div>
                        <div class="text-center">
                          <span class="badge badge-secondary" v-if="g.qtd_min === '0'">Opcional</span>
                          <span class="badge badge-primary" v-else-if="g.qtd_min > 0 && !(g.selecionados >= g.qtd_min)">Obrigatório</span>
                          <i class="fa fa-check text-primary icon-check" v-show="g.qtd_min > 0 && g.selecionados >= g.qtd_min"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="container px-0">
                  <div class="mt-3 border-bottom px-2" v-show="g.itens.length > 8" v-if="step === (index + 2)">
                    <div class="d-flex justify-content-between mb-3">
                      <VueFuse :list="g.itens" :fuse-opts="options" :map-results="true" placeholder="Pesquisar adicional.."
                               class="form-control mr-2" @fuse-results="handleAdicional" @fuse-input="(res) => termAdd = res" id="searchAdd"/>
                      <button class="btn btn-primary px-3"><i class="fa fa-search"></i></button>
                    </div>
                  </div>
                  <div class="lista-produto" v-for="a in searchAdicional" :class="{'produto-disable': parseInt(a.qtd_estoque) <= 0, 'produto-selecionado': a.qtd > 0}">
                    <div class="col lista-produto-item" @click="toggleAdicionais(g, a, index)">
                      <div class="mr-2">
                        <img :src="a.url_imagem" :alt="a.nome_produto" v-if="a.url_imagem"/>
                      </div>
                      <div>
                        <h6 class="m-0" style="font-size: 16px">{{a.nome_produto}}</h6>
                        <p class="text-muted m-0 tamanho-2">
                          <span class="d-block" v-if="g.max_item === '1'">Máximo 1</span>
                          <span v-if="a.descricao_produto" v-html="a.descricao_produto"></span>
                          <span class="font-weight-bold text-dark d-block" v-if="a.valor > 0">+ {{(a.valor * g.qtd_sel) | valor}}</span>
                          <produto-consumo :consumo="a.tipo_consumo" class="mt-1"/>
                        </p>
                        <div class="small" v-if="a.qtd_estoque <= 20">
                          <span class="badge badge-secondary" v-if="a.qtd_estoque <= 0">Sem estoque</span>
                          <span v-else-if="a.qtd_estoque == 1">Última unidade disponível</span>
                          <span v-else><b>{{a.qtd_estoque | percent}}</b> unidades disponíveis</span>
                        </div>
                      </div>
                    </div>
                    <div style="width: 110px">
                      <div class="pr-2 text-right" v-if="g.qtd_max === '1'" @click="toggleAdicionais(g, a, index)">
                        <i class="fa" style="font-size: 24px" :class="a.qtd > 0 ? 'fa-circle-o text-primary' : 'fa-circle text-light'"></i>
                      </div>
                      <div class="box-qtd" v-else>
                        <button type="button" class="btn botao-qtd" @click="removeAdicionais(g, a, index)"
                                :class="{'disabled' : parseInt(a.qtd) === 0}">
                          <i class="fa fa-minus"></i>
                        </button>
                        <div class="qtd-output text-dark"><b>{{a.qtd}}</b></div>
                        <button type="button" class="btn botao-qtd" @click="addAdicionais(g, a, index)"
                                :class="{'disabled' : a.qtd == parseInt(a.qtd_estoque) || (g.max_item === '1' && a.qtd)}">
                          <i class="fa fa-plus"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="observacaoProduto" class="container" :class="{'mt-3': step !== stepImg}" v-show="step === maxStep">
              <div class="alert alert-warning d-flex align-items-center mb-3" v-if="!empresaAberta">
                <i class="fa fa-info-circle mr-2"></i>
                <div>
                  <h6 class="mb-0">Não estamos atendendo!</h6>
                  <p class="small m-0">
                    Fique à vontade para olhar nossos produtos.
                  </p>
                </div>
              </div>
              <div class="d-flex justify-content-between align-items-center mb-3" v-else-if="step !== stepImg">
                <div>Resumo</div>
                <a href="javascript:" @click="step = 0" class="text-primary">
                  <small class="mr-1">Editar</small>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 512 512" fill="currentColor"><path d="M127.5 45c-41.7 8.8-74 41.4-82.5 83.2-2 9.6-2 13-1.8 131.1l.3 121.2 2.2 7.7c4.9 17.1 11.2 29.6 21.3 42.1 13.9 17.2 32.8 29.2 56.8 36l7.7 2.2 120.9.3c105.1.2 122.1 0 129.1-1.3 44.2-8.2 77.6-41.6 86-85.8 2.3-12 2.2-150 0-155.5-6.7-16-29.9-17-38.3-1.7-1.5 2.7-1.8 10.6-2.3 76-.6 81-.2 76.7-7.6 91.5-5.4 11-17 22.4-28.4 27.8-14.9 7.1-7.1 6.7-134.9 6.7-93.7 0-116.5-.3-121-1.4-18.1-4.4-35.2-18-42.8-34.1-7.1-15-6.7-7.2-6.7-135s-.4-120 6.7-135c5.4-11.4 16.8-22.9 27.8-28.4 14.9-7.3 10.5-6.9 91.7-7.5l73.1-.6 4.4-3c13.8-9.7 11.8-30.6-3.4-37-3.3-1.3-13-1.5-76.5-1.4-67.4 0-73.5.2-81.8 1.9"/><path d="M395.2 44.4c-11.6 2.9-19.7 8-33.5 21.5-7.1 6.9-13.9 14.4-15 16.6-2.8 5.4-2.8 13.6 0 19 2.7 5 59.5 61.6 64.3 64.1 4.9 2.5 13.4 2.4 18.5-.3 2.2-1.1 9.7-7.9 16.7-15.1 10.9-11.2 13.2-14.1 16.6-21.3 4.7-9.8 6.2-16.2 6.2-26.4s-1.5-16.6-6.2-26.3c-7.3-15.4-22.6-27.8-38.9-31.7-7.7-1.8-21.4-1.8-28.7-.1M298 132.2c-2.7.7-14.7 12.1-53.8 51.1-27.7 27.6-51.2 51.6-52.2 53.2-1 1.7-6.2 20.3-11.5 41.5-8 31.7-9.6 39.5-9.3 44.2.5 6.6 3.3 11.5 9.1 15.5 7.2 5 10.5 4.6 53.7-6.2 21.2-5.3 39.8-10.5 41.5-11.5 1.6-1 25.6-24.5 53.2-52.2 53.4-53.6 52.3-52.3 52.3-61.8-.1-7.7-3-11.4-32.8-41.3-30.5-30.6-34.6-33.8-42.6-33.6-2.3 0-5.7.5-7.6 1.1"/></svg>
                </a>
              </div>
              <div class="py-3 mb-1 border-top" v-if="dados.produto">
                <p class="mb-0"><b>{{dados.quantidade}}x</b>
                  - {{produto.nome_produto}}
                  <span class="small" v-if="dados.produto.principal !== '1'">({{dados.produto.nome_tabela}})</span>
                </p>
                <p v-for="d in dados.divisoes" class="m-0 pl-2 tamanho-2"> # {{d.nome_produto}}</p>
                <p v-for="d in dados.adicionais" class="m-0 pl-2 tamanho-2">
                  + <span v-show="d.qtd > 1">{{d.qtd}}x</span>
                  {{d.nome_produto}} <span v-show="d.valor > 0"> <b>{{((d.valor * d.qtd) * dados.quantidade) | valor}}</b></span>
                </p>
                <p class="mt-1 mb-0 tamanho-1" v-if="!beneficio">Total: <b>{{(dados.valor * dados.quantidade) | valor}}</b></p>
              </div>
              <div v-if="empresaAberta && !modo_catalogo">
                <div class="card px-2 py-3 mb-4" v-if="dados.produto && !beneficio">
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <h6 class="m-0 font-weight-bold">Quantidade</h6>
                      <div class="small" v-if="dados.produto.estoque === '1'">
                        <span v-if="dados.produto.qtd_estoque == 1">1 unidade disponível</span>
                        <span v-else-if="dados.produto.qtd_estoque <= 20"><b>{{dados.produto.qtd_estoque | percent}}</b> unidades disponíveis</span>
                      </div>
                    </div>
                    <div style="width: 125px;">
                      <quantidade @change="mudarQtd" :max="dados.produto.qtd_estoque"/>
                    </div>
                  </div>
                </div>
                <div v-if="empresa.json_config.obs_produto === '1'">
                  <div class="h6 mb-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" class="fi" viewBox="0 0 512 512"><path d="M233 27.7C139 37.8 61.5 102.6 35.5 193 26 226 24.3 266.9 31 300.1c8.2 40.6 28.3 80.6 54.7 109l4.3 4.6-17.1 12.8c-9.4 7.1-18.2 14.3-19.6 16.1-2.9 3.9-5.3 11.2-5.3 16.4 0 9.3 6.7 19.5 15.4 23.6l5.1 2.4h100.7c109.1 0 110.9-.1 135.6-5.6 43.1-9.6 85-33.4 115.9-65.7 68.2-71.5 83.7-175.3 39.3-262.3-31.1-60.7-87.8-104.5-154.6-119.3-16.3-3.6-31.5-5.1-50.7-4.9-10 0-19.8.3-21.7.5m55 33.4c86 14.6 151.4 81.7 163.4 167.8 2 14 2 38.4.1 52-6.6 46.3-30.5 90.9-65.3 121.6-30.8 27.3-70.7 45.1-110.7 49.5-6.7.7-38.6 1-96.9.8l-86.9-.3 17.2-12.8c17.5-13.1 19.5-15 21.1-20.8 1.9-6.5-.1-10.2-13.3-23.8-13.9-14.3-22.3-25.1-30.3-38.7-14.2-24.1-23-50.3-26.5-78.7-1.5-12.7-.7-43 1.6-55.7 15.9-88.4 87.6-154.3 177.3-163 12.3-1.2 35.7-.2 49.2 2.1"/><path d="M152.5 224.9c-9.2 2.4-17.3 9-21.5 17.6-3.4 6.9-3.5 19.8-.2 26.5 3.4 7.1 7.5 11.4 14.4 15.1 5.8 3.1 7 3.4 14.8 3.3 7.2 0 9.3-.4 13.6-2.6 7.5-4 10.7-7 14.5-14 3.1-5.8 3.4-7 3.4-14.8s-.3-9-3.4-14.8c-5.7-10.4-14.4-16-26-16.7-3.6-.2-7.9-.1-9.6.4m96 0c-9.2 2.4-17.3 9-21.5 17.6-3.4 6.9-3.5 19.8-.2 26.5 3.4 7.1 7.5 11.4 14.4 15.1 5.8 3.1 7 3.4 14.8 3.3 7.2 0 9.3-.4 13.6-2.6 7.5-4 10.7-7 14.5-14 3.1-5.8 3.4-7 3.4-14.8s-.3-9-3.4-14.8c-5.7-10.4-14.4-16-26-16.7-3.6-.2-7.9-.1-9.6.4m96 0c-9.2 2.4-17.3 9-21.5 17.6-3.4 6.9-3.5 19.8-.2 26.5 3.4 7.1 7.5 11.4 14.4 15.1 5.8 3.1 7 3.4 14.8 3.3 7.2 0 9.3-.4 13.6-2.6 7.5-4 10.7-7 14.5-14 3.1-5.8 3.4-7 3.4-14.8s-.3-9-3.4-14.8c-5.7-10.4-14.4-16-26-16.7-3.6-.2-7.9-.1-9.6.4"/></svg>
                    Observações ?
                  </div>
                  <div class="small mb-2">Adicionais pagos não serão inclusos.</div>
                  <textarea class="form-control" id="observacoes" rows="4" placeholder="Descreva aqui as observações deste produto. Ex: Retirar um ingrediente."
                            style="resize: none" v-model="dados.observacao"></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="border-top add-sacola">
        <div class="modo-catalago" v-if="step === maxStep && modo_catalogo">
          <span v-if="dados.valor > 0">{{(dados.valor * dados.quantidade) | valor}}</span>
          <span class="text-muted" v-else>R$ 0,00</span>
        </div>
        <div class="row no-gutters align-items-center" v-else>
          <div class="col-4 col-md-6 font-weight-bold" style="font-size: 1.1em">
            <span class="badge badge-warning text-white" v-if="beneficio"><icon name="pontos" size="12" class="mr-1"/> Benefício</span>
            <span v-else-if="dados.valor > 0">{{(dados.valor * dados.quantidade) | valor}}</span>
            <span class="text-muted" v-else>R$ 0,00</span>
          </div>
          <div class="col-8 col-md-6">
            <div v-if="step === maxStep">
              <button class="btn btn-primary btn-block btn-bottom" @click="adicionarSacola()" :disabled="!empresaAberta" v-if="beneficio">Resgatar</button>
              <button class="btn btn-primary btn-block btn-bottom" @click="adicionarSacola()" :disabled="!empresaAberta" v-else>
                <svg xmlns="http://www.w3.org/2000/svg" id="Bold" class="fi" viewBox="0 0 24 24" width="16" height="16" fill="#ffffff"><circle cx="7" cy="22" r="2"/><circle cx="17" cy="22" r="2"/><path d="M19.75,13.162A2.5,2.5,0,0,1,17.339,15H7.217a.329.329,0,0,1-.325-.3L6.036,8H10.5A1.5,1.5,0,0,0,12,6.5h0A1.5,1.5,0,0,0,10.5,5H5.653L5.391,2.939A3.327,3.327,0,0,0,2.087,0H1.5a1.5,1.5,0,0,0,0,3h.587a.329.329,0,0,1,.325.3l1.5,11.76A3.327,3.327,0,0,0,7.217,18H17.339a5.5,5.5,0,0,0,5.3-4.042l.016-.06A1.5,1.5,0,0,0,21.213,12h0a1.5,1.5,0,0,0-1.446,1.1Z"/><path d="M22.5,3H21V1.5a1.5,1.5,0,0,0-3,0V3H16.5a1.5,1.5,0,0,0,0,3H18V7.5a1.5,1.5,0,0,0,3,0V6h1.5a1.5,1.5,0,0,0,0-3Z"/></svg>
                <span class="ml-1">Adicionar</span>
              </button>
            </div>
            <button class="btn btn-primary btn-block btn-bottom" :disabled="btnAvancar < step" @click="nextStep(true)" v-else>
              Avançar <i class="fa fa-chevron-right ml-1" style="font-size: 14px"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Loading from './Loading'
  import Quantidade from './Quantidade';
  import CardInfo from "./CardInfo";
  import Icon from "./Icon";
  import VueFuse from 'vue-fuse'
  import ProdutoDescricao from "./ProdutoDescricao";
  import ProdutoConsumo from "./ProdutoConsumo";

  export default {
    name: "Produto",
    props: ['categoria','empresaAberta','beneficio','isComponente'],
    components: {ProdutoConsumo, ProdutoDescricao, Icon, CardInfo, Quantidade, Loading, VueFuse},
    data() {
      return {
        aberto: false,
        btnAvancar: false,
        avancar: true,
        fixo: true,
        produto: {},
        adicionais: [],
        total: 0,
        load: true,
        dados: {
          produto: {},
          adicionais: [],
          valor: 0,
          divisoes: [],
          quantidade: 1,
          observacao: ''
        },

        step: 0,
        stepImg: 0,
        maxStep: 6,

        termAdd: '',
        options: {
          shouldSort: true,
          threshold: 0.3,
          location: 0,
          distance: 100,
          minMatchCharLength: 1,
          keys: ["nome_produto", "descricao_produto", "nome_tabela"]
        },
        searchDivisao: [],
        searchAdicional: []
      }
    },

    methods: {
      getProduto(id, tabela) {
        this.fixo = !!tabela;
        this.avancar = true;
        this.btnAvancar = -1;
        this.step = 0;
        this.total = 0;
        this.produto = {};
        this.adicionais = [];
        this.dados = {
          id_produto: id,
          produto: {},
          adicionais: [],
          valor: 0,
          divisoes: [],
          quantidade: 1,
          observacao: ''
        };

        document.body.classList.add("modal-open");
        this.aberto = true;
        this.load = true;
        const url = this.$helpers.base_url(this, this.empresa);

        this.$http.get(url + 'produto/' + id, { params: {tipo_pedido: this.sacola.tipo_pedido} })
          .then(response => {
            if (!response.data.id_produto) {
              this.load = false;
              this.$swal('Não conseguimos carregar as informações deste produto.\nTente novamente mais tarde!')
              this.closeProduto();
              return;
            }

            this.produto = response.data;
            this.maxStep = this.produto.adicionais.length + 2;
            this.stepImg = this.produto.tabelas.length > 1 ? 0 : (this.produto.divisoes.length > 0 ? 1 : 2);

            if (tabela) {
              tabela = this.produto.tabelas && this.produto.tabelas.find(p => p.id_tabela_preco === tabela);

              if (!tabela) {
                this.$swal('Este produto está indisponível no momento');
                this.$emit('retorno');
                this.closeProduto();
                return;
              }
            }

            if (tabela || (this.produto.tabelas && this.produto.tabelas.length === 1)) {
              this.selecionarTamanho(tabela || this.produto.tabelas[0]);
              this.nextStep(false);
            }

            this.$helpers.trackPixel(this, 'ViewContent', this.empresa, true, {
              content_name: this.produto.nome_produto,
              content_category: this.produto.nome_categoria,
              content_ids: [this.produto.id_produto],
              content_type: 'product'
            });

            this.load = false;

          }, res => {
            this.load = false;
            this.closeProduto();
            this.$swal(res.data.msg || "Não conseguimos carregar as informações deste produto.\nTente novamente mais tarde!");
          });
      },

      handleResult(r) {
        this.searchDivisao = r;
      },

      handleAdicional(r) {
        this.searchAdicional = r;
      },

      limparAdicional(adicionais) {
        this.termAdd = "";
        this.$store.state.load = false;
        this.searchAdicional = adicionais;
        const input = document.getElementById("searchAdd");

        if (input) {
          input.value = "";
          this.$helpers.focusrElement('searchAdd');
        }
      },

      selecionarDivisaoValor(somar) {
        let valor = 0;
        if (this.dados.divisoes.length > 0) {
          //venda fracionada
          if (this.produto.tipo_venda === '2') {
            this.dados.divisoes.forEach((d) => {
              valor += parseFloat(d.valor);
            });

            valor = valor / this.dados.divisoes.length;

          } else {
            this.dados.divisoes.forEach((d) => {
              if (valor < parseFloat(d.valor)) {
                valor = parseFloat(d.valor);
              }
            });
          }

          if (somar) {
            this.dados.valor += valor;

          } else {
            this.dados.valor -= valor;
          }
        }
      },

      selecionarDivisao(d) {
        if (this.dados.produto.id_tabela) {
          const divisaoQtd = parseInt(this.produto.divisao);
          let divisao = this.dados.divisoes.find(div => div.id_tabela_preco === d.id_tabela_preco);

          if (!divisao && (this.dados.divisoes.length !== divisaoQtd || divisaoQtd === 1)) {
            this.selecionarDivisaoValor(false);

            if (divisaoQtd === 1) {
              this.dados.divisoes = [];
            }

            this.dados.divisoes.push({
              id_produto: d.id_produto,
              id_tabela: d.id_tabela,
              id_tabela_preco: d.id_tabela_preco,
              nome_produto: d.nome_produto,
              ref_produto: d.ref_produto,
              tipo_consumo: d.tipo_consumo,
              valor: d.valor,
              valor_base: d.valor_base,
              pontos: d.pontos || 0,
            });

            this.selecionarDivisaoValor(true);

          } else if (divisao) {
            this.selecionarDivisaoValor(false);
            this.dados.divisoes = this.dados.divisoes.filter(div => div.id_tabela_preco !== d.id_tabela_preco);
            this.selecionarDivisaoValor(true);

          } else {
            this.$swal('Máximo de sabor permitido: ' + this.produto.divisao + '');
            return;
          }

          this.btnAvancar = (this.dados.divisoes.length === parseInt(this.produto.divisao)) ? 1 : 0;

          if (this.btnAvancar === 1) {
            this.animateCSS('btnAvancar', 'bounceIn');

            if (this.dados.divisoes.length === parseInt(this.produto.divisao)) {
              this.avancarAutomatico();
            }
          }

        } else {
          this.$swal('Selecione um item antes de selecionar o sabor');
        }
      },

      selecionarTamanho(t) {
        if (t.estoque === '1' && parseInt(t.qtd_estoque) <= 0) {
          this.$swal('Sem estoque', 'Este produto está indisponível no momento');
          return;
        }

        this.selecionarDivisaoValor(false);
        this.dados.divisoes = [];

        if (t.id_tabela_preco === this.dados.produto.id_tabela_preco) {
          this.dados.produto = {};
          this.dados.valor -= parseFloat(t.valor);
          this.btnAvancar = -1;

        } else {
          if (this.dados.produto.valor) {
            this.dados.valor -= parseFloat(this.dados.produto.valor);
          }

          this.dados.produto = t;
          this.dados.valor += parseFloat(t.valor);
          this.btnAvancar = 0;

          if (this.dados.produto.turnos && this.dados.produto.disponivel === '0') {
            this.$swal('Disponibilidade', 'Este produto está disponível para pedidos somente das: ' + this.dados.produto.turnos + '.');

          } else if (this.produto.tabelas.length > 1 && !this.fixo) {
            this.animateCSS('btnAvancar', 'bounceIn');
            this.avancarAutomatico("Selecionando..");
          }

          this.$helpers.trackAnalytics("view_item", {
            currency: "BRL",
            value: parseFloat(t.valor),
            items: [{
              item_id: t.id_tabela_preco,
              item_name: this.produto.nome_produto
            }]
          });
        }
      },

      removeAdicionais(g, a, index) {
        const qtd_sel = parseInt(g.qtd_sel || '1');
        let adicional = this.dados.adicionais.find(obj => obj.id_grupo_adicional === a.id_grupo_adicional && obj.id_tabela_preco === a.id_tabela_preco);

        if (adicional) {
          const qtd = (parseInt(adicional.qtd) - qtd_sel);

          if (qtd <= 0) {
            this.dados.adicionais = this.dados.adicionais.filter(obj => obj !== adicional);
          }

          adicional.qtd = qtd;
          g.selecionados = (g.selecionados - qtd_sel);
          this.dados.valor -= (parseFloat(a.valor) * qtd_sel);
          this.btnAvancar = (g.selecionados >= g.qtd_min ? (index + 2) : (index + 1));
        }
      },

      addAdicionais(g, a, index) {
        if (!(g.qtd_max > 0 && parseInt(g.qtd_max) === parseInt(g.selecionados))) {
          const qtd_sel = parseInt(g.qtd_sel || '1');
          let adicional = this.dados.adicionais.find(obj => obj.id_grupo_adicional === a.id_grupo_adicional && obj.id_tabela_preco === a.id_tabela_preco);

          if (parseInt(a.qtd_estoque) <= ((adicional ? adicional.qtd : 0) + qtd_sel)) {
            this.$swal('Estoque insuficiente');
            return;
          }

          if (!adicional) {
            a.qtd = qtd_sel;
            a.index = index;
            a.id_grupo = g.id_grupo;
            this.dados.adicionais.push(a);

          } else if (g.max_item === '1') {
            this.$swal('Máximo 1');
            return;

          } else {
            adicional.qtd = (adicional.qtd + qtd_sel);
          }

          g.selecionados = (parseInt(g.selecionados) + qtd_sel);
          this.dados.valor += (parseFloat(a.valor) * qtd_sel);
          this.btnAvancar = (g.selecionados >= g.qtd_min ? (index + 2) : (index + 1));

          if (g.selecionados === parseInt(g.qtd_max)) {
            this.avancarAutomatico();

          } else if (this.termAdd.trim()) {
            this.$store.state.load = "Aguarde..";
            setTimeout(() => {
              this.limparAdicional(g.itens);
            }, 800);
          }

        } else {
          this.$swal("A quantidade máxima para o adicional \"" + g.nome_grupo + "\" é: " + g.qtd_max);
        }
      },

      toggleAdicionais(g, a, index) {
        if (g.qtd_max === '1') {
          const add = this.dados.adicionais.find(g => g.id_grupo_adicional === a.id_grupo_adicional);

          if (!add) {
            this.addAdicionais(g, a, index);

          } else {
            this.removeAdicionais(g, add, index);

            if (a !== add) {
              this.addAdicionais(g, a, index);
            }
          }

        } else {
          if (a.qtd > 0) {
            this.removeAdicionais(g, a, index);

          } else {
            this.addAdicionais(g, a, index);
          }
        }
      },

      validarBtnAdicionar() {
        let tabelaExiste = this.dados.produto.id_tabela_preco;

        let valido = true;
        this.produto.adicionais.forEach((g) => {
          if (g.qtd_min > 0 && g.selecionados < parseInt(g.qtd_min)) {
            valido = false;
          }
        });

        let divisao = (this.dados.divisoes.length === parseInt(this.produto.divisao)) || this.produto.divisoes.length === 0;
        return (tabelaExiste && valido && divisao);
      },

      mudarQtd(qtd) {
        this.dados.quantidade = qtd;
      },

      adicionarSacola() {
        if (!this.validarBtnAdicionar()) {
          return;
        }

        if (this.dados.valor <= 0) {
          this.$swal('Este produto está disponível apenas para valores maiores que R$ 0,00');
          return;
        }

        if (this.dados.produto.turnos && this.dados.produto.disponivel === '0') {
          this.$swal('Disponibilidade', 'Este produto está disponível para pedidos somente das: ' + this.dados.produto.turnos + '.');
          return;
        }

        if (this.beneficio) {
          this.$emit('retorno', this.dados);
          this.closeProduto();
          return;
        }

        const sacola = this.$store.state.sacola || { produtos: [] };
        sacola.produtos.push(this.dados);
        this.$store.commit('setProdutosSacola', sacola);
        this.closeProduto();

        // eventos
        this.$helpers.trackPixel(this, 'AddToCart', this.empresa);
        this.$helpers.googleTag(this, '2');
        this.$helpers.trackAnalytics('add_to_cart', {
          currency: "BRL",
          value: (this.dados.valor * this.dados.quantidade),
          items: [{
            item_id: this.dados.produto.id_tabela_preco,
            item_name: this.produto.nome_produto,
            quantity: this.dados.quantidade
          }]
        });
      },

      closeProduto(confirm) {
        if (confirm && this.step > 0 && this.produto.adicionais.length && !this.modo_catalogo) {
          this.$swal({
            text: 'Deseja voltar? Este produto não será adicionado ao seu pedido.',
            buttons: ["Não", "Sim"],
            dangerMode: true,
          }).then((r) => {
            if (r) {
              document.body.classList.remove("modal-open");
              this.aberto = false;
              this.animateCSS('sacolaAnimated', 'bounceIn')

              if (!this.isComponente) {
                const id_categoria = this.categoria ? this.categoria.id_categoria : null
                window.history.replaceState(null, null, `${window.location.pathname}?id=${id_categoria}`);
              }
            }
          });

        } else {
          document.body.classList.remove("modal-open");
          this.aberto = false;
          this.animateCSS('sacolaAnimated', 'bounceIn')

          if (!this.isComponente) {
            const id_categoria = this.categoria ? this.categoria.id_categoria : null
            window.history.replaceState(null, null, `${window.location.pathname}?id=${id_categoria}`);
          }
        }
      },

      animateCSS(element, animationName, callback) {
        const node = document.getElementById(element);

        if (node) {
          node.classList.add('animated', animationName);

          function handleAnimationEnd() {
            node.classList.remove('animated', animationName);
            node.removeEventListener('animationend', handleAnimationEnd);

            if (typeof callback === 'function') callback()
          }

          node.addEventListener('animationend', handleAnimationEnd)
        }
      },

      previusStep() {
        this.avancar = false;

        if (this.step > 0) {
          const step = (this.step === 2 && this.produto.divisao === '0' ? 0 : (this.step - 1));
          const index = (step - 2);
          this.step = 9999;

          setTimeout(() => {
            this.step = step;

            this.$nextTick(() => {
              if (this.step === 0 && (this.produto.tabelas.length === 1 || this.fixo)) {
                this.$emit('retorno');
                this.closeProduto();
                return;

              } else if (index >= 0 && this.produto.adicionais.length > index) {
                const g = this.produto.adicionais[index];

                if (g) {
                  this.searchAdicional = g.itens;
                }
              }

              this.scrollTop();
            });
          }, 100);

        } else {
          this.$emit('retorno');
          this.closeProduto();
        }
      },

      avancarAutomatico(texto) {
        if (this.avancar) {
          this.$store.state.load = texto || "Avançando..";
          setTimeout(() => {
            this.$store.state.load = false;
            this.nextStep(true);
          }, 500);
        }
      },

      nextStep(scroll) {
        if (this.btnAvancar < this.step || this.step >= this.maxStep) {
          return;
        }

        this.avancar = true;
        this.termAdd = "";
        const step = (this.step === 0 && this.produto.divisao === '0' ? 2 : (this.step + 1));
        const index = (step - 2);

        setTimeout(() => {
          this.step = step;
          this.$nextTick(() => {
            if (index >= 0 && this.produto.adicionais.length > index) {
              const g = this.produto.adicionais[index];

              if (g) {
                this.searchAdicional = g.itens;
                this.btnAvancar = (g.selecionados >= g.qtd_min ? (index + 2) : (index + 1));
              }
            }
          });

          if (this.step === this.maxStep && this.dados.adicionais.length) {
            this.dados.adicionais = this.dados.adicionais.sort((a, b) => a.index - b.index);
          }

          if (scroll) {
            this.scrollTop();
          }
        }, 100);
      },

      scrollTop() {
        if (window.innerWidth > 768) {
          const container = document.querySelector('.container-produto');

          if (container) {
            container.scrollTo({ top: 0 });
          }

        } else {
          this.$helpers.scrollTo('containerProduto');
        }
      },

      getStatusEmpresa() {
        if (!this.empresaAberta && !sessionStorage.getItem('restauranteFechado')) {
          this.$swal("Desculpe, não estamos atendendo no momento! Sinta-se à vontade para conferir nossos produtos.");
          sessionStorage.setItem('restauranteFechado','true');
        }
      },

      openProduto(dados) {
        if (!this.isComponente) {
          const url = `${window.location.pathname}?id=${dados.id_categoria || ''}&produto=${dados.id}`;
          window.history.replaceState(null, null, url);
        }

        this.getStatusEmpresa();
        this.getProduto(dados.id, dados.id_tabela);
      }
    },

    computed: {
      empresa() {
        return this.$store.state.empresa
      },

      sacola() {
        return this.$store.state.sacola
      }
    }
  }
</script>

<style scoped>
  .icon-check {
    padding-right: 12px;
  }

  .modal-produto {
    display: block;
    position: fixed; /* Stay in place */
    z-index: 1040; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    background-color: rgb(0, 0, 0); /* Fallback color */
    background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
    overflow: auto;
  }

  /* Modal Content/Box */
  .modal-produto-content {
    width: 100%;
    background-color: #fefefe;
  }

  .header-produto {
    position:fixed;
    right:0;
    top:0;
    left:0;
    z-index:1030;
  }

  .add-sacola {
    bottom: env(safe-area-inset-bottom, 10px);
    position:fixed;
    right:0;
    left:0;
    z-index:1030;
    padding: 0.5rem 15px;
    background-color: #ffffff;
  }

  .ios_platform .add-sacola {
    padding-bottom: 32px;
  }

  .container-produto {
    padding: 68px 0 156px;
    min-height: 100vh;
    overflow: auto;
  }

  .produto-disable {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .produto-selecionado {
    color: var(--lecard-primary);
  }

  .topbar-produto {
    height: 76px;
    display: flex;
    align-items: center;
  }

  .lista-produto-item {
    padding: 10px 4px;
    display: flex;
    align-items: center;
    min-height: 86px;
  }

  .lista-produto-item img {
    width: 52px;
    height: 52px;
    object-fit: cover;
    border-radius: 4px;
  }

  .modo-catalago {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 52px;
    font-weight: bold;
    font-size: 1.2em;
  }

  @media (min-width: 768px) {
    .modal-produto-content {
      margin: 15px auto;
      width: 768px;
      position: relative;
      border-radius: 6px;
      overflow: hidden;
    }

    .header-produto {
      position: static;
    }

    .add-sacola {
      position: static;
      padding: 12px;
    }

    .container-produto {
      overflow: auto;
      min-height: auto;
      height: calc(90vh - 130px);
      padding: 0 0 12px 0;
      /*scrollbar-width: none;*/
    }

    .container-produto::-webkit-scrollbar {
      /*display: none;*/
    }

    .topbar-produto {
      position: static!important;
    }
  }
</style>